import { render } from "./BaseSideNav.vue?vue&type=template&id=76902f86&scoped=true"
import script from "./BaseSideNav.vue?vue&type=script&lang=js"
export * from "./BaseSideNav.vue?vue&type=script&lang=js"

import "./BaseSideNav.vue?vue&type=style&index=0&id=76902f86&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76902f86"]])

export default __exports__